import { combineReducers } from 'redux';
import user from './user';
import customers from './customers';
import creditLimits from './credit-limits';
import longSteelOrders from './long-steel-orders';
import newLongSteelOrders from './new-long-steel-orders';
import invoices from './invoices';
import longSteelShoppingCart from './long-steel-shopping-cart';
import manifestations from './manifestations';
import helpCenter from './help-center';
import longSteelOrderItemSearch from './long-steel-order-item-search';
import dashboard from './dashboard';
import downloadArea from './download-area';
import fabricationProjects from './fabrication-projects';
import fabricationMockups from './fabrication-mockups';
import fabricationContracts from './fabrication-contracts';
import acessManagement from './access-management';
import fabrication from './fabrication';
import fabricationPurchaseOrder from './fabrication-purchase-order';
import contractsAndConstructions from './contracts-and-constructions';
import toastMessages from './toast';
import notifications from './notifications';
import fabricationOrders from './fabrication-orders';
import observability from './observability';
import loyalty from './loyalty';
import orderSimulateCheckoutMvp from './order-simulate-checkout-mvp';
import cartItemsMvp from './cart-items-mvp/reducer';
import crossSell from './cross-sell/';
import auth from './auth';
import { modalPriorityReducer } from './modal-priority/reducer';
import { entryOrderReceiversReducer } from './entry-order/reducer';
import newLongSteelOnboarding from './new-long-steel-onboarding';
import connectivityReducer from './connectivity/reducer';
import abandonedCartReducer from './abandoned-cart';

export default combineReducers({
  auth,
  user,
  acessManagement,
  customers,
  notifications,
  dashboard,
  downloadArea,
  longSteelOrders,
  newLongSteelOrders,
  invoices,
  creditLimits,
  longSteelShoppingCart,
  manifestations,
  helpCenter,
  longSteelOrderItemSearch,
  loyalty,
  fabrication,
  fabricationPurchaseOrder,
  contractsAndConstructions,
  fabricationContracts,
  fabricationProjects,
  fabricationMockups,
  fabricationOrders,
  observability,
  toastMessages,
  orderSimulateCheckoutMvp,
  cartItemsMvp,
  crossSell,
  openModalPriority: modalPriorityReducer,
  entryOrderReceivers: entryOrderReceiversReducer,
  newLongSteelOnboarding,
  connectivity: connectivityReducer,
  abandonedCart: abandonedCartReducer
});
